// Bun inlines BUN_PUBLIC_* only when the var is set; see api.ts.
function publicUrl(): string | undefined {
  try {
    return process.env.BUN_PUBLIC_APP_URL
  } catch {
    return undefined
  }
}

export const APP_URL = publicUrl() || 'http://localhost:3000'
